export const defaultSEO = {
  title: 'SciSprint 2026 | Agent Scientist Hackathon Series | Boltzmann Labs & ChemBio AI',
  description: 'Four Weeks. Four Scientific Domains. Twelve Real World Research Challenges. One Scientific Revolution. Join SciSprint 2026 powered by Agent Scientist, developed by Boltzmann Labs with ChemBio AI.',
  keywords: 'SciSprint 2026, Agent Scientist, Boltzmann Labs, ChemBio AI, scientific hackathon, protein engineering, drug discovery, retrosynthesis, RNA design',
  image: '/scisprint2026_poster.jpg',
  url: 'https://chembioai.org/events'
};

export const seoConfig = {
  '/events': {
    title: 'Events & Hackathons | ChemBio AI',
    description: 'Explore featured and completed scientific hackathons, workshops, and AI discovery challenges at ChemBio AI.',
    keywords: 'ChemBio AI events, SciSprint, scientific hackathon, AI drug discovery, biology hackathon',
    image: '/scisprint2026_poster.jpg',
    url: 'https://chembioai.org/events'
  },
  '/scisprint-2026': {
    title: 'SciSprint 2026 | Agent Scientist Hackathon Series | Boltzmann Labs & ChemBio AI',
    description: 'Four Weeks. Four Scientific Domains. Twelve Real World Research Challenges. One Scientific Revolution. Join SciSprint 2026 powered by Agent Scientist, developed by Boltzmann Labs with ChemBio AI.',
    keywords: 'SciSprint 2026, Agent Scientist, Boltzmann Labs, ChemBio AI, scientific hackathon, protein engineering, drug discovery, retrosynthesis, RNA design',
    image: '/scisprint2026_poster.jpg',
    url: 'https://chembioai.org/events/scisprint-2026'
  }
};

export function getSEOData(path) {
  return seoConfig[path] || defaultSEO;
}

